import { Injectable } from "@angular/core";
import {
  AcepSSOService,
  GlobalDomOpsService,
  GlobalDataOpsService,
  CommonOperationsService
} from "@acepteam/globalspack";
import { GroupPortalDomService, GroupPortalDataService } from "../../services";
import {
  DomService,
  DataService,
  HelperService,
  LoggerService
} from "../../../core/services";
import { MyAccountDataOpsService } from "../../services/my-account-dataops.service";
import { HttpClient, HttpResponse } from "@angular/common/http";
import {
  ChapterDetails,
  ChapterInfo
} from "../../../shared/models/chapter-details";
import { ProductSubType } from "../../../shared/enums/xrm.constants";
import { OrderGenProduct } from "../../../shared/models";
import { CustomerAddress } from "../../../shared/models/my-account-data.models";
import { getPrimaryAddress } from "../../helpers/mapper";

@Injectable({
  providedIn: "root"
})
export class Component1Service {
  constructor(
    private ssoService: AcepSSOService,
    private globalDomOpsService: GlobalDomOpsService,
    private groupPortalDataService: GroupPortalDataService,
    private memberAppDomService: GroupPortalDomService,
    private domService: DomService,
    private globalDataOpsService: GlobalDataOpsService,
    private dataService: DataService,
    private myAccountDataService: MyAccountDataOpsService,
    private commonOpsService: CommonOperationsService,
    private helperService: HelperService,
    private loggerService: LoggerService,
    private http: HttpClient
  ) { }


  giveSomeTestData(): ChapterDetails {
    let chapterDetails: ChapterDetails = {
      chapters: [
        {
          id: "1",
          name: "Florida College of Emergency Physicians",
          code: "FL",
          selected: false,
          isPrimary: false
        },

        {
          id: "2",
          name: "Maryland College of Emergency Physicians",
          code: "MD",
          selected: true,
          isPrimary: true
        },

        {
          id: "4",
          name: "Government Services Chapter",
          code: "US",
          selected: false,
          isPrimary: false
        }
      ]
    };

    return chapterDetails;
  }
}
